import { lastAssistantMessageIsCompleteWithToolCalls, type UIMessage } from 'ai';

/**
 * Pure predicate for the AI SDK's `sendAutomaticallyWhen` agentic tool loop.
 *
 * The loop must NOT continue once the user has requested a stop. The SDK's
 * own `stop()` only aborts a live `activeResponse`; clicked in the gap
 * between two requests (status transiently `ready`, `activeResponse`
 * cleared) it does nothing, and the queued continuation would otherwise
 * re-submit. Gating the loop on explicit stop intent (owned by
 * `AtlasChatTransport`) closes that race regardless of whether the
 * in-flight tool finished with an error or cleanly.
 */
export function shouldContinueAgentLoop({
  stopRequested,
  messages,
}: {
  stopRequested: boolean;
  messages: UIMessage[];
}): boolean {
  if (stopRequested) {
    return false;
  }
  return lastAssistantMessageIsCompleteWithToolCalls({ messages });
}
